"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M21.6585 0H2.3415A2.3415 2.3415 0 0 0 0 2.3415v19.317A2.3415 2.3415 0 0 0 2.3415 24h19.317A2.3416 2.3416 0 0 0 24 21.6585V2.3415A2.3415 2.3415 0 0 0 21.6585 0zM18.439 13.4634a2.9268 2.9268 0 1 1-2.9268-2.9268c.4033.0003.802.0849 1.1707.2482V7.0244a.294.294 0 0 0-.3512-.2868l-5.8537 1.255a.2928.2928 0 0 0-.2341.2856v7.5267a2.9271 2.9271 0 0 1-3.4978 2.8706 2.9275 2.9275 0 0 1-2.2996-2.2996A2.927 2.927 0 0 1 7.317 12.878c.4032.0004.802.0849 1.1707.2482V8.2759a2.0605 2.0605 0 0 1 1.6191-2.0031l5.8537-1.2539a2.0485 2.0485 0 0 1 2.2792 1.1219 2.048 2.048 0 0 1 .1992.8836v6.439z"
}), 'Audio');

exports.default = _default;